import { getGetAccessTokenProvider, onAuthProviderSet } from './auth'
import { HUB_NAMESPACE } from './constants'
import { Hub } from './election'
import { initA2UIService } from './services/a2ui-service'
import { initChatService } from './services/chat-service'
import { NotifyService } from './services/notify-service'
import { createSyslogService } from './services/syslog-service'

// Create a single Hub instance for the application - only on client side
let wsHub: Hub | undefined

export const getWsHub = (): Hub | undefined => {
    // Only create hub in browser environment
    if (typeof window === 'undefined') {
        return undefined
    }

    if (!wsHub) {
        wsHub = new Hub(HUB_NAMESPACE)
        // Attempt registration immediately after creation
        tryRegister()
        // Set up auth provider callback
        onAuthProviderSet(() => tryRegister())
    }

    return wsHub
}

const tryRegister = (): void => {
    const getAccessToken = getGetAccessTokenProvider()
    if (!getAccessToken || !wsHub) {
        return
    }

    // Register notify service (handles connection and notify messages)
    wsHub.register(new NotifyService(getAccessToken))

    // Initialize and register chat service
    const chatService = initChatService(getAccessToken)
    wsHub.register(chatService)

    // Initialize and register A2UI service
    const a2uiService = initA2UIService()
    wsHub.register(a2uiService)

    // Register syslog viewer service (multi-tab coordination for OPFS hydration)
    wsHub.register(createSyslogService())
}
